<template>
    <input type="text" :value="value" @input="this.$emit('update:value', $event.target.value);">
</template>

<script>
    export default {
        props: {
            value: String,
        },
    }
</script>

<style scoped>
input{
    box-sizing: border-box;
    border: 1px solid rgb(222, 230, 234);
    border-radius: 8px;
    background: rgb(255, 255, 255);
    height: 44px;
    width: 100%;
    padding-left: 10px;

    color: rgb(5, 5, 5);
    font-family: Satoshi;
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
}
input.error{
    border: 1px solid red;
}
</style>